import { __rest, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';

var LEVEL_CLASSES = {
    level1: 'nv-fine-print-1',
    level1gray: 'nv-fine-print-1-gray',
    level2: 'nv-fine-print-2',
};
var NvFinePrint = function (_a) {
    var _b = _a.element, element = _b === void 0 ? 'p' : _b, _c = _a.level, level = _c === void 0 ? 'level1' : _c, className = _a.className, style = _a.style, children = _a.children, dataAriaOrInvalidTSIdentifiers = __rest(_a, ["element", "level", "className", "style", "children"]);
    var Element = element;
    var finePrintClassName = LEVEL_CLASSES[level];
    return (React.createElement(Element, __assign({}, dataAriaOrInvalidTSIdentifiers, { className: classNames(finePrintClassName, className), style: style }), children));
};

export { LEVEL_CLASSES, NvFinePrint as default };
//# sourceMappingURL=NvFinePrint.esm.js.map
